/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_SkipInputs */



/**
* | output |
* | --- |
* | "I already know oneAI, skip the tour" |
*
* @param {Onboarding_Tour_SkipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_skip = /** @type {((inputs?: Onboarding_Tour_SkipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_SkipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ich kenne oneAI schon, Tour überspringen")
	return /** @type {LocalizedString} */ ("I already know oneAI, skip the tour")
});